module.exports = __webpack_public_path__ + "static/media/logout-off.c77fe790.svg";